module.exports = __webpack_public_path__ + "media/site/images/banners/banner-solutions-c3fe86862bdf881f4560b9fc45150878.svg";